export const getEditedCommentId = state => state.commentEdit;
export const isEditingComment = state => Boolean(getEditedCommentId(state));
